import arrayLinks from './arrayLinks';

export default arrayLinks;
